<template>
    <div class="body d-flex py-lg-3 py-md-2">
        <div class="container-xxl">
            <div class="row g-3">
                <!-- Left Column with Tabs -->
                <div class="col-xl-8 col-lg-7 col-md-12 rightborderSec">
                    <!-- Entity header (redesign) -->
                    <div class="wx-hero wx-hero-light" v-if="taskViewData">
                        <div class="wx-crumbs">
                            <router-link v-if="taskViewData.project" :to="{ path: 'project', query: { id: taskViewData.project?.id } }"><span class="wx-lv p">P</span>{{ taskViewData.project?.code }}</router-link>
                            <router-link v-else-if="taskViewData.hosting" :to="{ path: 'host', query: { id: taskViewData.hosting?.id } }"><span class="wx-lv h">H</span>{{ taskViewData.hosting?.code }}</router-link>
                            <span class="wx-sep">›</span>
                            <span class="wx-crumb-cur"><span class="wx-lv t">T</span>Task</span>
                        </div>
                        <div class="wx-hero-row">
                            <div class="wx-hero-main">
                                <h1 class="wx-hero-title">{{ taskViewData.info?.title }}</h1>
                                <div class="wx-hero-meta">
                            <div class="status-dropdown wx-hero-status">
                                <button class="status-button justify-content-center" v-if="taskViewData"
                                    :style="getStatusStyle(taskViewData.status?.id)">
                                    <i :class="getStatusIcon(taskViewData.status?.id)"
                                        v-if="canEditTask(taskViewData) || canEditAllTasks || superUser"></i>
                                    {{ getCurrentStatus(taskViewData.status?.id) }}
                                    <i class="fa fa-caret-down"
                                        v-if="canEditTask(taskViewData) || canEditAllTasks || superUser"></i>
                                </button>

                                <!-- Dropdown Content (Visible on Hover) -->
                                <div class="status-dropdown-content"
                                    v-if="canEditTask(taskViewData) || canEditAllTasks || superUser">
                                    <button v-for="status in statuses" :key="status.id"
                                        @click="selectStatus(taskViewData.info?.id, status.id)"
                                        :style="getStatusStyle(status.id)"
                                        :class="{ 'active-status': taskViewData?.status.id === status.id }">
                                        <i :class="status.icon"></i>
                                        {{ status.description }}
                                    </button>
                                </div>
                            </div>

                                    <span class="wx-chip wx-chip-late" v-if="daysLeft(taskViewData.info?.endDate_formatted) !== null && daysLeft(taskViewData.info?.endDate_formatted) < 0 && taskViewData.status?.id != 3">Εκπρόθεσμο</span>
                                    <span class="wx-chip" v-if="taskViewData.info?.endDate_formatted">Λήξη {{ taskViewData.info.endDate_formatted }}</span>
                                    <span class="wx-chip" v-if="taskViewData.manager">Manager · {{ taskViewData.manager.username }}</span>
                                </div>
                            </div>
                            <div class="wx-hero-team">
                                <template v-for="user in taskViewData.assigned" :key="user.id">
                                    <img v-if="user?.avatar_file_name" :src="`/storage/avatars/${user.avatar_file_name}`" :title="user.username" class="wx-av" />
                                    <span v-else class="wx-av" :title="user.username">{{ initials(user.username) }}</span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="wx-tabrow">
                    <!-- Tabs -->
                    <ul class="nav nav-tabs mb-3 p-0 gap-xl-3 gap-1 fs-6 justifyContentbetmob" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'info' }"
                                @click.prevent="setActiveTab('info')" href="#">Info</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'managerBrief' }"
                                @click.prevent="setActiveTab('managerBrief')" href="#">Manager's Brief</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'subtasks' }"
                                @click.prevent="setActiveTab('subtasks')" href="#">Subtasks</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'taskChat' }"
                                @click.prevent="setActiveTab('taskChat')" href="#">Task Chat</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'files' }"
                                @click.prevent="setActiveTab('files')" href="#">Files</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'report' }"
                                @click.prevent="setActiveTab('report')" href="#">Report</a>
                        </li>
                    </ul>
                        <div class="wx-tab-actions">
                        <div class="status-button-wrapper">
                            <!-- Edit Button Info-->
                            <button class="btn btn-dark btn-sm p-1"
                                v-if="!isEditingInfo && activeTab === 'info' && taskViewData && (canEditTask(taskViewData) || canEditAllTasks || superUser)"
                                @click="editTask">
                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                            </button>

                            <!-- Save and Cancel Buttons -->
                            <div v-if="isEditingInfo && activeTab === 'info'" class="editing-actions">
                                <!-- Save Button -->
                                <button class="btn btn-secondary p-1" @click="saveInfo">
                                    <i class="wx-ic wx-ic-check" title="Save"></i>
                                </button>

                                <!-- Cancel Button -->
                                <button class="btn btn-danger p-1 mt-xl-2 mt-0" @click="cancelEditing">
                                    <!-- <i class="wx-ic wx-ic-x" title="Cancel"></i> -->
                                    <i class="wx-ic wx-ic-x" title="Cancel"></i>
                                </button>
                            </div>


                            <!-- Edit Button Manager-->
                            <button class="btn btn-dark btn-sm p-1"
                                v-if="!isEditingManagersBrief && activeTab === 'managerBrief' && taskViewData && (taskViewData.info.managerId == currentUserInfo?.id || superUser || canEditAllTasks)"
                                @click="editTaskManager">
                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                            </button>

                            <!-- Save and Cancel Buttons -->
                            <div v-if="isEditingManagersBrief && activeTab === 'managerBrief'" class="editing-actions">
                                <!-- Save Button -->
                                <button class="btn btn-secondary mb-0 p-1" @click="saveManager">
                                    <i class="wx-ic wx-ic-check" title="Save"></i>
                                </button>

                                <!-- Cancel Button -->
                                <button class="btn btn-danger mt-2 p-1" @click="cancelEditingManager">
                                    <i class="wx-ic wx-ic-x" title="Cancel"></i>
                                </button>
                            </div>
                        </div>
                        </div>
                    </div>

                    <!-- Tab Content -->
                    <div class="tab-content pb-5">
                        <!-- Info Tab -->
                        <div v-if="activeTab === 'info'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body p-0" v-if="!isEditingInfo">
                                    <div v-html="taskViewData.info?.body" v-if="taskViewData" v-target-blank></div>
                                </div>
                                <div class="card-body p-0" v-if="isEditingInfo">
                                    <div class="mb-3" v-if="taskViewData">
                                        <Editor api-key="no-api-key" :init="tinymceInit"
                                            v-model="taskViewData.info.body"></Editor>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="activeTab === 'report'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body">
                                    <div
                                        class="card-header py-1 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between flex-wrap">

                                        <div class="d-flex w-100 justify-content-start align-items-center gap-2">
                                            <!-- Date From Input -->
                                            <div class="d-flex text-nowrap align-items-center gap-1">
                                                <label for="filterDateFrom" class="form-label mb-0">Ημ/νία από:</label>
                                                <input type="date" class="form-control"
                                                    v-model="filtersReport.dateFrom">
                                            </div>

                                            <!-- Date To Input -->
                                            <div class="d-flex text-nowrap align-items-center gap-1">
                                                <label for="filterDateTo" class="form-label mb-0">Ημ/νία έως:</label>
                                                <input type="date" class="form-control" v-model="filtersReport.dateTo">
                                            </div>

                                            <!-- Search Button -->
                                            <div class="col-auto">
                                                <button type="button" class="btn btn-secondary"
                                                    @click="() => { fetchReportData(); }">
                                                    <i class="icofont-search me-1 fs-6"></i> Search
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Total Project Hours -->
                                    <div v-if="totalTaskHours" class="mt-3">
                                        <h5><strong>Total Task Hours:</strong> {{ totalTaskHours }}</h5>
                                    </div>

                                    <div class="row clearfix g-3">
                                        <div class="col-lg-12">
                                            <div class="card mb-3">
                                                <div class="card-body p-0 mt-3 table-responsive">
                                                    <table id="reports"
                                                        class="table table-hover align-middle mb-0 mis_table"
                                                        style="width:100%">
                                                        <thead>
                                                            <tr class="reportsHeader">
                                                                <th style="width:20%; color:white">User</th>
                                                                <th style="width:20%; color:white">Hours</th>
                                                                <th style="width:40%; color:white">Description</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="user in reports" :key="user.userId">
                                                                <!-- Row for user, click to toggle visibility of task hours -->
                                                                <tr @click="toggleShow(user)" style="cursor: pointer;">
                                                                    <td>{{ user.username }}</td>
                                                                    <td>{{ user.user_total }}</td>
                                                                </tr>

                                                                <!-- Task hours for the user, use v-show to toggle visibility -->
                                                                <tr v-if="user.show"
                                                                    v-for="(hour, hIndex) in user.hours" :key="hIndex"
                                                                    class="reports_tasks" style="font-weight: lighter;">
                                                                    <td colspan="1">{{ formatDate(hour.day) }}</td>
                                                                    <td colspan="1">{{ hour.total_hours }}</td>
                                                                    <td colspan="1">{{ hour.body }}</td>

                                                                </tr>
                                                            </template>

                                                            <!-- Fallback for no data -->
                                                            <tr v-if="reports.length === 0">
                                                                <td colspan="4">No data</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                        <div v-if="activeTab === 'files'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body px-0">
                                    <div class="d-flex" v-if="!taskViewData?.info?.shared_link"><button
                                            style="color: var(--secondary-color);"
                                            @click="createFolder(taskViewData?.info?.id)" class="btn btn-dark">Create
                                            folder</button></div>
                                    <iframe :src="taskViewData?.info?.shared_link"
                                        style="width: 100%; height: 500px;"></iframe>
                                </div>
                            </div>
                        </div>

                        <!-- Manager's Brief Tab -->
                        <div v-if="activeTab === 'managerBrief'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body" v-if="!isEditingManagersBrief">
                                    <div v-html="taskViewData.info?.manager_brief" v-if="taskViewData" v-target-blank>
                                    </div>
                                </div>
                                <div class="card-body" v-if="isEditingManagersBrief">
                                    <div class="mb-3" v-if="taskViewData">
                                        <Editor api-key="no-api-key" :init="tinymceInit"
                                            v-model="taskViewData.info.manager_brief"></Editor>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-4 rightCol mb-5 mb-xl-0 mobilefilters"
                            v-if="activeTab == 'subtasks'">
                            <div class="card border-0 mb-2">
                                <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between">
                                    <div class="w-100">
                                        <button type="button" class="w-100 btn justify-content-start"
                                            style="color:var(--secondary-color);" @click="createSubtask"
                                            v-if="createSubtask">
                                            <i class="icofont-plus me-2 fs-6"></i> Create Subtask
                                        </button>
                                    </div>
                                </div>
                                <div class="filter-section mt-3">
                                    <!-- Status Tabs -->
                                    <div>
                                        <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2 align-items-center justify-content-between"
                                            role="tablist">
                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '0',
                                                    'nav-link text-center': filters.statusId != '0',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '0', page: 1 })"
                                                    href="#" role="tab">

                                                    <span class="nav-item nav-link">All</span>
                                                </a>
                                            </li>

                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '2' || filters.statusId == undefined,
                                                    'nav-link text-center': filters.statusId != '2' && filters.statusId != undefined,
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '2', page: 1 })"
                                                    href="#" role="tab">

                                                    <span class="wx-st wx-st-progress" title="In Progress">In progress</span>
                                                </a>
                                            </li>
                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '3',
                                                    'nav-link text-center': filters.statusId != '3',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '3', page: 1 })"
                                                    href="#" role="tab">
                                                    <span class="wx-st wx-st-done" title="Done">Done</span>
                                                </a>
                                            </li>
                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '1',
                                                    'nav-link text-center': filters.statusId != '1',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '1', page: 1 })"
                                                    href="#" role="tab">
                                                    <span class="wx-st wx-st-hold" title="On Hold">On hold</span>
                                                </a>
                                            </li>
                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '5',
                                                    'nav-link text-center': filters.statusId != '5',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '5', page: 1 })"
                                                    href="#" role="tab">
                                                    <span class="wx-st wx-st-ongoing" title="On going">On going</span>
                                                </a>
                                            </li>

                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '4',
                                                    'nav-link text-center': filters.statusId != '4',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '4', page: 1 })"
                                                    href="#" role="tab">
                                                    <span class="wx-st wx-st-archived" title="Archived">Archived</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="d-flex align-items-center mb-3 justify-content-center col-md-12">
                                        <input id="main-search-input" type="search" class="form-control rounded"
                                            placeholder="Αναζήτηση..." aria-label="search"
                                            aria-describedby="addon-wrapping" />
                                    </div>
                                    <!-- Date Filters -->
                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="start-date" class="form-label me-2 w-25 text-nowrap">Start
                                            date:</label>
                                        <input type="date" id="start-date" v-model="startDate"
                                            class="form-control w-100" />
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="end-date" class="form-label me-2 w-25 text-nowrap">End date:</label>
                                        <input type="date" id="end-date" v-model="endDate" class="form-control w-100" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="activeTab === 'subtasks'" class="tab-pane fade show active">
                            <div id="projectTableMobile" class="d-flex w-100 flex-column mobileRows gap-2"
                                v-for="(subtask, index) in data" :key="subtask.info.id"
                                :class="{ 'selected': selectedSubTaskIds.includes(subtask.info.id) }"
                                @click="toggleSubTaskSelection(subtask.info.id, $event)">
                                <div class="w-100 d-flex justify-content-between align-items-center">
                                    <div class="d-flex flex-column gap-1 col-8">
                                        <router-link :to="{ path: 'subtask', query: { id: subtask.info?.id } }">
                                            <span class="fw-bold">{{ subtask.info?.title }}</span>
                                        </router-link>
                                    </div>
                                    <div class="col-3">
                                        <div class="dropdown-container w-100">
                                            <button class="dropbtn w-100" :style="getStatusStyle(subtask.status?.id)">
                                                {{ getCurrentStatus(subtask.status?.id) }}
                                                <i class="fa fa-caret-down"
                                                    v-if="canEditSubtask(subtask) || canEditAllSubTasks || superUser"></i>
                                            </button>
                                            <div class="dropdown-content shadow"
                                                v-if="canEditSubtask(subtask) || canEditAllSubTasks || superUser">
                                                <button v-for="status in statuses" :key="status.id"
                                                    @click="updateStatus(subtask.info?.id, status.id)"
                                                    :style="getStatusStyle(status.id)">
                                                    {{ status.description }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-100 d-flex justify-content-between pb-2 align-items-center">
                                    <div>
                                        <div v-if="subtask.manager?.avatar_file_name" class="small-column">
                                            <img :src="`/storage/avatars/${subtask.manager.avatar_file_name}`"
                                                width="30" class="managerProfIcon" :title="subtask.manager.username">
                                        </div>
                                        <div v-else class="small-column">
                                            {{ subtask.manager?.username }}
                                        </div>
                                    </div>
                                    <div class="d-flex gap-2 py-1 align-items-center text-secondary ps-1">
                                        <div><i class="icofont-ui-calendar me-1"></i> {{ subtask.info?.startDate }}
                                        </div>
                                        <div><i class="icofont-ui-calendar me-1"></i> {{ subtask.info?.endDate }}</div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="button-group d-flex">
                                            <div class="icon-wrapper">
                                                <router-link
                                                    :to="{ path: 'subtask', query: { id: subtask?.info?.id, activeTab: 'taskChat' } }">
                                                    <button class="btn btn-dark comments p-1">
                                                        <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                        <span class="unread-comments"
                                                            v-if="subtask.unread_comments > 0">{{
                                                            subtask.unread_comments
                                                            }}</span>
                                                    </button>
                                                </router-link>
                                            </div>
                                            <div class="icon-wrapper"
                                                v-if="canEditSubtask(subtask) || canEditAllSubTasks || superUser">
                                                <button class="btn btn-dark p-1"
                                                    @click.prevent="editTask(subtask.info.id)">
                                                    <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Tasks Tab -->
                        <div v-if="activeTab === 'subtasks'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body table-responsive">
                                    <table id="myProjectTable" class="table table-hover align-middle mb-0 mis_table"
                                        style="width:100%">
                                        <thead>
                                            <tr>
                                                <th class="text-start">Subtask <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('subtasks.title')"></i></th>
                                                <th style="width: 5%">
                                                    <div v-if="superUser" class="d-flex align-items-center">
                                                        <div class="custom-dropdown">
                                                            <!-- Dropdown Button -->
                                                            <div class="dropdown-btn" @click="toggleDropdown">
                                                                <span>{{ selectedManager?.username || 'Επιλογη Manager'
                                                                    }}</span>
                                                                <i class="icofont-rounded-down"></i>
                                                            </div>

                                                            <!-- Dropdown List -->
                                                            <ul v-if="isDropdownOpen" class="dropdown-options">
                                                                <!-- All Managers Option -->
                                                                <li
                                                                    @click="selectManager({ id: null, username: 'All Managers' })">
                                                                    All Managers
                                                                    <img src="../assets/images/icons8-superman.svg"
                                                                        alt="Superman Icon" class="menu-img ms-2"
                                                                        style="width: 1.5em" />
                                                                </li>

                                                                <!-- Managers List -->
                                                                <li v-for="manager in managers" :key="manager.id"
                                                                    @click="selectManager(manager)">
                                                                    {{ manager.username }}
                                                                    <img v-if="String(manager.id) !== currentUserId()"
                                                                        src="../assets/images/icons8-superman.svg"
                                                                        alt="Superman Icon" class="menu-img ms-2"
                                                                        style="width: 1.5em" />
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <!-- Non-superUser Fallback -->
                                                    <div v-else>
                                                        Manager
                                                        <i class="fa fa-sort sorting-icon"
                                                            @click.prevent="sortBy('m.username')"></i>
                                                    </div>
                                                </th>

                                                <th>Date Start <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('subtasks.startDate')"></i></th>
                                                <th>Date End <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('subtasks.endDate')"></i>
                                                </th>
                                                <th>Status <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('subtasks.statusId')"></i>
                                                </th>
                                                <th class="no-after"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(task, index) in data" :key="task.info.id" @click="handleRowClick(task.info?.id, $event)">

                                                <td class="text-start"><router-link
                                                        :to="{ path: 'subtask', query: { id: task.info?.id } }">
                                                        {{ task.info?.title }}
                                                    </router-link></td>
                                                <td>
                                                    <img class="managerProfIcon" v-if="task.manager?.avatar_file_name"
                                                        :src="`/storage/avatars/${task.manager.avatar_file_name}`"
                                                        width="35" :title="task.manager.username">
                                                    <span v-else> {{ task.manager?.username }} </span>
                                                </td>

                                                <td>{{ task.info?.startDate }}</td>
                                                <td>{{ task.info?.endDate }}</td>

                                                <td>
                                                    <!-- Custom Status Dropdown for Each Task -->
                                                    <div class="status-dropdown">
                                                        <button class="status-button">
                                                            <span class="wx-status-pill" :style="getStatusStyle(task.status?.id)">{{ getCurrentStatus(task.status?.id) }}</span>
                                                            <!-- <i :class="getStatusIcon(task.status.id)"></i>
                                                            {{ getCurrentStatus(task.status.id) }} -->
                                                            <i class="fa fa-caret-down"
                                                                v-if="canEditTask(taskViewData) || canEditAllTasks || superUser"></i>
                                                        </button>
                                                        <div class="status-dropdown-content-tasks"
                                                            v-if="canEditTask(task) || canEditAllTasks || superUser">
                                                            <button v-for="status in statuses" :key="status.id"
                                                                @click="updateSubtaskStatusId(task.info.id, status.id)"
                                                                :class="{ 'active-status': task.status.id === status.id }">
                                                                <!-- <i :class="status.icon"></i>
                                                                {{ status.description }} -->
                                                                <span class="wx-status-pill" :style="getStatusStyle(status?.id)">{{ getCurrentStatus(status?.id) }}</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>

                                                    <div class="button-group">
                                                        <div class="icon-wrapper">
                                                            <router-link
                                                                :to="{ path: 'subtask', query: { id: task?.info?.id, activeTab: 'subTaskChat' } }">

                                                                <button class="btn btn-dark px-2 py-1">
                                                                    <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                                    <span class="unread-comments"
                                                                        v-if="task.unread_comments > 0">{{
                                                                        task.unread_comments }}</span>
                                                                </button></router-link>
                                                        </div>
                                                        <!--  <div class="icon-wrapper">
                                                            <button class="btn btn-dark"
                                                                @click.prevent="editSubTask(task.info.id)"
                                                                v-if="canEditSubtask(task) || canEditAllSubtasks || superUser">
                                                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                                            </button>
                                                        </div>
                                                        <div class="icon-wrapper">
                                                            <button class="btn btn-dark"
                                                                @click.prevent="openArchiveConfirmation(task.info?.id)"
                                                                v-if="canArchiveSubtask || superUser">
                                                                <i class="wx-ic wx-ic-trash" title="Archive"></i>
                                                            </button>
                                                        </div> -->
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="!data || !data.length">
                                                <td colspan="6" class="text-center">No subtasks found</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <nav aria-label="Page navigation">
                                        <ul class="pagination mt-4"
                                            v-if="paginationLinks && paginationLinks.length > 0">
                                            <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                                :key="index" :class="{ active: paginationLink.active }">
                                                <router-link
                                                    :to="{ path: 'task', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
                                                    v-if="paginationLink.url">
                                                    <span class="page-link" v-html="paginationLink.label"></span>
                                                </router-link>
                                                <span class="page-link" v-else v-html="paginationLink.label"></span>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>

                        <!-- Task Chat Tab -->
                        <div v-if="activeTab === 'taskChat'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body">
                                    <ul ref="chatHistory" class="chat-history list-unstyled">
                                        <li class="mb-3 d-flex" v-if="taskViewData && taskViewData.comments"
                                            v-for="comment in taskViewData.comments" :key="comment.id" :class="{
                                                'justify-content-end': comment.author?.id == currentUser,
                                                'justify-content-start': comment.author?.id != currentUser
                                            }">
                                            <div style="width:50%;">
                                                <span class="text-muted small d-flex align-items-center" :class="{
                                                    'justify-content-end': comment.author?.id == currentUser,
                                                    'justify-content-start': comment.author?.id != currentUser
                                                }">
                                                    <img v-if="comment.author?.avatar_file_name"
                                                        :src="`/storage/avatars/${comment.author?.avatar_file_name}`"
                                                        width="25" class="me-2" style="width: 2.5rem;
                                                        height: 2.5rem;
                                                        border-radius: 50%;" :title="comment.author.username" />
                                                    <h6 v-else class="fw-bolder">{{ comment.author.username }}</h6>
                                                </span>
                                                <div class="chat-message p-2 mt-1 rounded"
                                                    v-html="parseLinks(comment.info?.comment)">
                                                </div>
                                                <span class="text-muted small">
                                                    <i class="icofont icofont-date"></i><i class="wx-ic wx-ic-calendar" title="Edit"></i>{{ comment.info.created_at
                                                    }}
                                                </span>
                                                <div class="mt-1 d-flex align-items-center justify-content-end"
                                                    v-if="comment.read_by_users && comment.read_by_users.length">
                                                    <span class="me-2 text-muted small">Διαβάστηκε από:</span>

                                                    <div class="d-flex align-items-center avatar-stack">
                                                        <div v-for="(user, index) in comment.read_by_users"
                                                            :key="user.id" :title="user.username" class="avatar-wrapper"
                                                            :style="{ left: `${index * 16}px` }">
                                                            <img v-if="user.avatar_file_name"
                                                                :src="`/storage/avatars/${user.avatar_file_name}`"
                                                                :alt="user.username"
                                                                class="rounded-circle border avatar-img" />
                                                            <span v-else class="avatar-text">{{
                                                                user.username.charAt(0).toUpperCase() }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </li>
                                    </ul>
                                    <div class="d-flex align-items-end gap-2">
                                        <textarea id="commentTextarea" class="form-control position-relative"
                                            placeholder="Μήνυμα..." v-model="newComment" @input="filterUsernames"
                                            @keydown.enter.prevent="submitComment"></textarea>

                                        <!-- Autocomplete Dropdown -->
                                        <div v-if="showAutocomplete" class="autocomplete-dropdown" :style="{
                                            top: `${dropdownTop}px`,
                                            left: `${dropdownLeft}px`,
                                            width: `${dropdownWidth}px`
                                        }">
                                            <ul class="list-unstyled m-0 p-2">
                                                <li v-for="user in filteredUsernames" :key="user.id"
                                                    @click="selectUsername(user.username)" class="autocomplete-item">
                                                    {{ user.username }}
                                                </li>
                                            </ul>
                                        </div>
                                        <button @click.prevent="submitComment" class="btn sendComment mt-2">
                                            <i class="fa fa-paper-plane"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Column with Task Details -->
                <div class="col-xl-4 col-lg-5 col-md-12 mb-xl-0 mb-5" v-if="activeTab != 'subtasks' && taskViewData">
                    <div class="card wx-details">
                        <div class="card-body">

                            <button class="btn btn-dark p-1 belowEditbtn"
                                v-if="!isEditingGeneral && (superUser || canEditAllTasks || canEditTask(taskViewData))"
                                @click="editTaskGeneral" style="position: absolute; top: 25px; right: 10px;">
                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                            </button>

                            <!-- Save Button -->
                            <button class="btn btn-secondary mb-0 mb-xl-3 p-1" @click="saveGeneral"
                                v-if="isEditingGeneral" style="position: absolute; top: 25px; right: 10px;">

                                <i class="wx-ic wx-ic-check" title="Save"></i>
                            </button>

                            <!-- Cancel Button -->
                            <button class="btn btn-danger mt-2 p-1" @click="cancelEditingGeneral"
                                v-if="isEditingGeneral" style="position: absolute; top: 65px; right: 10px;">
                                <i class="wx-ic wx-ic-x" title="Cancel"></i>
                                <!-- <i class="wx-ic wx-ic-x" title="Cancel"></i> -->
                            </button>

                            <div class="row px-xl-4 px-1 gap-3" v-if="!isEditingGeneral">
                                <div class="d-flex flex-column-desk">
                                    <div class="col-6 col-xl-12 fs-6 mb-xl1 mb-0 p-0 dateprojectdiv px-0"><i class="wx-ic wx-ic-calendar me-1" title="Edit"></i>
                                        <span>Start Date:<strong> {{taskViewData.info.startDate_formatted
                                                }}</strong></span>
                                    </div>
                                    <div class="col-6 col-xl-12 fs-6 p-0 dateprojectdiv">
                                        <i class="wx-ic wx-ic-calendar me-1" title="Edit"></i>
                                        <span>End Date:<strong> {{taskViewData.info.endDate_formatted }}</strong></span>
                                    </div>
                                </div>

                                <br /><br />
                                <div class="col-12 gap-2 align-items-center mb-1" style="display: inline-flex;">
                                    <strong>Creator:</strong> <img v-if="taskViewData?.creator?.avatar_file_name"
                                        :src="`/storage/avatars/${taskViewData?.creator?.avatar_file_name}`" width="35"
                                        :title="taskViewData.creator.username" class="managerProfIcon" /><span v-else
                                        class="avatar-text2" :title="taskViewData.creator.username"> {{
                                        taskViewData.creator.username.charAt(0).toUpperCase() }}</span>
                                </div>
                                <div class="col-12 gap-2 align-items-center mb-1" style="display: inline-flex;">
                                    <strong>Manager:</strong> <img v-if="taskViewData?.manager?.avatar_file_name"
                                        :src="`/storage/avatars/${taskViewData?.manager?.avatar_file_name}`" width="35"
                                        :title="taskViewData.manager.username" class="managerProfIcon" /> <span v-else
                                        class="avatar-text2" :title="taskViewData.manager.username"> {{
                                        taskViewData.manager.username.charAt(0).toUpperCase() }}</span>
                                </div>
                                <div class="col-12 gap-2 d-flex align-items-center mb-1" style="display: inline-flex;">
                                    <div class="col-12 gap-2 d-flex align-items-center flex-wrap"><strong>Assigned
                                            Users:</strong>
                                        <div v-for="user in taskViewData.assigned" :key="user.id"
                                            style="display: inline-flex; align-items: center;">
                                            <img v-if="(user?.avatar_file_name && user?.active === 1)"
                                                :src="`/storage/avatars/${user.avatar_file_name}`" width="25"
                                                :title="user.username" class="managerProfIcon" /><span
                                                v-if="!user?.avatar_file_name && user?.active === 1"
                                                class="avatar-text2" :title="user.username"> {{
                                                user.username.charAt(0).toUpperCase()
                                                }}</span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row" v-if="isEditingGeneral" style="max-width: 800px; margin: auto;">
                                <div class="col-9 d-flex align-items-center mb-3">
                                    <strong class="me-2" style="min-width: 100px;">Start Date:</strong>
                                    <input type="date" class="form-control flex-grow-1" v-model="taskData.startDate" />
                                </div>
                                <div class="col-9 d-flex align-items-center mb-3">
                                    <strong class="me-2" style="min-width: 100px;">End Date:</strong>
                                    <input type="date" class="form-control flex-grow-1" v-model="taskData.endDate" />
                                </div> <br /><br />

                                <div class="col-9 d-flex align-items-center mb-3"
                                    v-if="superUser || canEditTaskCreator">
                                    <strong class="me-2" style="min-width: 100px;">Creator:</strong>
                                    <Select2 :options="allData.users" v-model="taskData.createdBy"
                                        :settings="select2SettingsProject" class="flex-grow-1" />
                                </div>
                                <div class="col-9 d-flex align-items-center mb-3">
                                    <strong class="me-2" style="min-width: 100px;">Manager:</strong>
                                    <Select2 ref="managerSelectTask" :options="filteredUsersForManagerTask"
                                        v-model="taskData.managerId" :settings="select2SettingsSubTask"
                                        class="flex-grow-1" />
                                </div>
                                <div class="col-9 d-flex align-items-center mb-3">
                                    <strong class="me-2" style="min-width: 100px;">Assigned
                                        Users:</strong>
                                    <Select2 ref="assignedUsersSelectTask" :options="filteredUsersForAssignedTask"
                                        v-model="taskData.assignedUsers"
                                        :settings="{ ...select2SettingsSubTask, multiple: true }" class="flex-grow-1" />
                                </div>
                            </div> -->
                            <div class="row" v-if="isEditingGeneral" style="max-width: 800px; margin: auto;">
                                <!-- Start Date -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex align-items-center">
                                        <strong class="me-2">Start Date:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <input type="date" class="form-control" v-model="taskData.startDate" />
                                    </div>
                                </div>

                                <!-- End Date -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex align-items-center">
                                        <strong class="me-2">End Date:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <input type="date" class="form-control" v-model="taskData.endDate" />
                                    </div>
                                </div>

                                <!-- Creator (conditional) -->
                                <div class="col-12 row mb-3" v-if="superUser || canEditTaskCreator">
                                    <div class="col-md-3 d-flex align-items-center">
                                        <strong class="me-2">Creator:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="allData.users" v-model="taskData.createdBy"
                                            :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>

                                <!-- Manager -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex align-items-center">
                                        <strong class="me-2">Manager:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 ref="managerSelectTask" :options="filteredUsersForManagerTask"
                                            v-model="taskData.managerId" :settings="select2SettingsSubTask"
                                            class="form-control" />
                                    </div>
                                </div>

                                <!-- Assigned Users -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex align-items-center">
                                        <strong class="me-2">Assigned Users:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 ref="assignedUsersSelectTask" :options="filteredUsersForAssignedTask"
                                            v-model="taskData.assignedUsers"
                                            :settings="{ ...select2SettingsSubTask, multiple: true }"
                                            class="form-control" />
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>

                <!-- Right Column with Project Details -->
                <div class="col-xl-4 col-lg-5 col-md-4 rightCol mb-5 mb-xl-0 desktopfilters"
                    v-if="activeTab == 'subtasks'">

                    <div class="card border-0 mb-2">
                        <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between">
                            <div class="w-100">
                                <button type="button" class="w-100 btn justify-content-start"
                                    style="color:var(--secondary-color); font-weight:bold"
                                    @click.prevent="createSubtask" v-if="canCreateSubtask || superUser">
                                    <i class="icofont-plus me-2 fs-6"></i>Create Subtask
                                </button>
                            </div>

                        </div>

                        <div class="filter-section mt-3">


                            <!-- Status Tabs -->
                            <div>

                                <!-- Status Tabs -->
                                <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2 align-items-center justify-content-between"
                                    role="tablist">
                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '0',
                                            'nav-link text-center': filters.statusId != '0',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '0', page: 1 })"
                                            href="#" role="tab">
                                            <span class="nav-item nav-link">All</span>
                                        </a>
                                    </li>

                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '2' || filters.statusId == undefined,
                                            'nav-link text-center': filters.statusId != '2' && filters.statusId != undefined,
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '2', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-progress" title="In Progress">In progress</span>
                                        </a>
                                    </li>
                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '3',
                                            'nav-link text-center': filters.statusId != '3',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '3', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-done" title="Done">Done</span>
                                        </a>
                                    </li>
                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '1',
                                            'nav-link text-center': filters.statusId != '1',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '1', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-hold" title="On Hold">On hold</span>
                                        </a>
                                    </li>
                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '5',
                                            'nav-link text-center': filters.statusId != '5',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '5', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-ongoing" title="On going">On going</span>
                                        </a>
                                    </li>

                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '4',
                                            'nav-link text-center': filters.statusId != '4',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '4', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-archived" title="Archived">Archived</span>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                            <div class="d-flex align-items-center mb-3 justify-content-center col-md-12">

                                <input id="main-search-input" type="search" class="form-control"
                                    placeholder="Αναζήτηση..." aria-label="search" aria-describedby="addon-wrapping" />
                            </div>
                            <!-- Date Filters -->
                            <div class="mb-3 d-flex align-items-center">
                                <label for="start-date" class="form-label me-2 w-25 text-nowrap">Start date:</label>
                                <input type="date" id="start-date" v-model="startDate" class="form-control w-100" />
                            </div>

                            <div class="mb-3 d-flex align-items-center">
                                <label for="end-date" class="form-label me-2 w-25 text-nowrap">End date:</label>
                                <input type="date" id="end-date" v-model="endDate" class="form-control w-100" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="unsavedChangesModal" tabindex="-1" aria-labelledby="unsavedChangesLabel"
                    aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="unsavedChangesLabel">Unsaved Changes</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                You may have unsaved changes. Are you sure you want to leave this page?
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-sm btn-danger text-white" @click="confirmLeave">Leave</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Create Task -->
                <div class="modal fade" id="create-task-form" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title fw-bold">Edit Task</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <input type="hidden" name="projectId" v-model="taskData.projectId">
                            <div class="modal-body">
                                <!-- Task Data Form -->
                                <div class="mb-3">
                                    <label class="form-label">Title</label>
                                    <input type="text" class="form-control" placeholder="Title" name="title"
                                        v-model="taskData.title">
                                </div>
                                <div class="mb-3"
                                    v-if="(taskData && taskData.createdBy == currentUserInfo?.id) || superUser || taskData.createdBy == '' || taskData.createdBy == null">
                                    <label for="taskDescriptionTinyMce" class="form-label">Creator's brief</label>
                                    <Editor api-key="no-api-key" :init="tinymceInit" v-model="taskData.body"></Editor>
                                </div>
                                <div class="mb-3"
                                    v-if="(taskData && currentUserInfo && taskData.managerId == currentUserInfo.id)">
                                    <label for="taskManagerBriefTinyMce" class="form-label">Manager's brief</label>
                                    <Editor api-key="no-api-key" :init="tinymceInit" v-model="taskData.manager_brief">
                                    </Editor>
                                </div>
                                <div class="mb-3" v-if="superUser || canEditTaskCreator">
                                    <label class="form-label">Creator</label>
                                    <Select2 :options="allData.users" v-model="taskData.createdBy"
                                        :settings="select2SettingsProject" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Status</label>
                                    <Select2 :options="allData.statuses" v-model="taskData.statusId"
                                        :settings="select2SettingsTask" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Manager</label>
                                    <Select2 :options="allData.users" v-model="taskData.managerId"
                                        :settings="select2SettingsTask" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Assigned users</label>
                                    <Select2 :options="allData.users" v-model="taskData.assignedUsers"
                                        :settings="{ ...select2SettingsTask, multiple: true }" />
                                </div>
                                <div class="deadline-form">
                                    <form>
                                        <div class="row g-3 mb-3">
                                            <div class="col">
                                                <label for="taskStartDate" class="form-label">Start Date</label>
                                                <input type="date" class="form-control" name="startDate"
                                                    v-model="taskData.startDate">
                                            </div>
                                            <div class="col">
                                                <label for="taskEndDate" class="form-label">End Date</label>
                                                <input type="date" class="form-control" name="endDate"
                                                    v-model="taskData.endDate">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div id="create-project-errors"></div>
                            </div>
                            <div class="modal-footer">
                                <!--                     <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
 --> <button type="button" class="btn btn-secondary" @click.prevent="submitTaskForm">Update</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="archiveConfirmationModal" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title fw-bold">Confirm Archive</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <p>Are you sure you want to archive this subtask?</p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-danger" @click="confirmArchive">Yes,
                                    Archive</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Subtask Modal -->
                <div class="modal fade" id="create-subtask-form" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title fw-bold">Sub Task Data</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <input type="hidden" name="id" id="id" v-model="subTaskData.id">
                                <div class="mb-3">
                                    <label for="taskTitle" class="form-label">Title</label>
                                    <input type="text" class="form-control" placeholder="Title" name="title"
                                        v-model="subTaskData.title">
                                </div>
                                <div class="mb-3"
                                    v-if="(subTaskData && subTaskData.createdBy == currentUserInfo?.id) || superUser || subTaskData.createdBy == '' || subTaskData.createdBy == null">
                                    <label class="form-label">Creator's brief<sup>*</sup></label>
                                    <Editor api-key="no-api-key" :init="tinymceInit" v-model="subTaskData.body">
                                    </Editor>
                                </div>
                                <div class="mb-3"
                                    v-if="(subTaskData && currentUserInfo && subTaskData.managerId == currentUserInfo.id)">
                                    <label class="form-label">Manager's brief</label>
                                    <Editor api-key="no-api-key" :init="tinymceInit"
                                        v-model="subTaskData.manager_brief"></Editor>
                                </div>
                                <div class="mb-3" v-if="superUser || canEditSubTaskCreator">
                                    <label class="form-label">Creator</label>
                                    <Select2 :options="allData.users" v-model="subTaskData.createdBy"
                                        :settings="select2SettingsProject" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Status<sup>*</sup></label>
                                    <Select2 :options="allData.statuses" v-model="subTaskData.statusId"
                                        :settings="select2SettingsSubTask" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Manager<sup>*</sup></label>
                                    <Select2 ref="managerSelectSubTask" :options="filteredUsersForManagerSubTask"
                                        v-model="subTaskData.managerId" :settings="select2SettingsSubTask" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Assigned users</label>
                                    <Select2 ref="assignedUsersSelectSubTask" :options="filteredUsersForAssignedSubTask"
                                        v-model="subTaskData.assignedUsers"
                                        :settings="{ ...select2SettingsSubTask, multiple: true }" />
                                </div>
                                <div class="deadline-form">
                                    <form>
                                        <div class="row g-3 mb-3">
                                            <div class="col">
                                                <label for="taskStartDate" class="form-label">Start Date<sup>*</sup></label>
                                                <input type="date" class="form-control" name="startDate"
                                                    v-model="subTaskData.startDate">
                                            </div>
                                            <div class="col">
                                                <label for="projectEndDate" class="form-label">End Date<sup>*</sup></label>
                                                <input type="date" class="form-control" name="endDate"
                                                    v-model="subTaskData.endDate">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div id="create-project-errors"></div>
                            </div>
                            <div class="modal-footer">
                                <!--                     <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
 --> <button type="button" class="btn btn-secondary" @click.prevent="submitSubTaskForm">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { initials, daysLeft, editorSkin } from '@/wxHelpers';
import { statusStyle } from '@/status';
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
import { useFetchData } from '@/composables/useFetchData';
import { createFolder as creeateTaskFolder, getClientsServicesStatusesUsers, createComment, updateInfo, updateManager, updateGeneral, getReportData } from '@/services/tasks';
import { fetchAll } from '@/services/subtasks';
import { get as getTask, searchUsers } from '@/services/tasks';
import { get as getSubtask } from '@/services/subtasks';
import { createOrUpdate as createOrUpdateSubtask, massArchiveSubTasks } from '@/services/subtasks';
import { createOrUpdate as createOrUpdateTask } from '@/services/tasks';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import { fetchUserInfo } from '@/services/user';
import { all } from 'axios';
import { updateTaskStatus } from '@/services/todo';
import { updateSubtaskStatus } from '@/services/todo';
import { fetchManagers } from '@/services/followup';


export default {
    name: 'Task',
    components: {
        Editor,
        Select2
    },
    data() {
        return {
            showUnsavedModal: false,
            isEditingInfo: false,
            isEditingGeneral: false,
            isEditingManagersBrief: false,
            pendingNavigation: null, // Store pending navigation details
            statusesReport: [],
            totalTaskHours: '',
            reports: [],

            filtersReport: {
                dateFrom: '',
                dateTo: '',
                userId: [],
                statusId: []
            },
        };
    },
    methods: {
        initials,
        daysLeft,
        currentUserId() {
            return localStorage.getItem('current_user_id');
        },
        async fetchReportData() {
            const { dateFrom, dateTo, userId, statusId } = this.filtersReport; // Access filtersReport correctly
            const taskId = this.$route.query.id; // Use route query to get the projectId

            try {
                // Prepare the data to send in the request
                const requestData = {
                    date_from: dateFrom,
                    date_to: dateTo,
                    statusId: Array.isArray(statusId) ? statusId : [statusId],
                    userId: Array.isArray(userId) ? userId : [userId],
                    taskId: taskId // Pass the project ID to the API
                };

                // Call getReportData from the services file
                const response = await getReportData({
                    date_from: dateFrom,
                    date_to: dateTo,
                    userId: Array.isArray(userId) ? userId : [userId],
                    statusId: Array.isArray(statusId) ? statusId : [statusId],
                    taskId: taskId // Pass the projectId in the body or as part of the URL path
                });

                // Check if the response is successful and handle the data
                if (response.data.success) {
                    this.reports = response.data.data.data.users.map(user => ({
                        ...user,
                        show: false, // Add show property to toggle user details
                    }));
                    // 🔍 Log the hours for each user


                    this.totalTaskHours = response.data.data.data.total_task_hours;
                    this.statuses = response.data.data.data.project_statuses;
                } else {
                    console.error('Failed to fetch report data:', response.data.message);
                }
            } catch (error) {
                console.error('Error fetching report data:', error);
            }
        },
        scrollToBottom() {
            // Scroll the chat container to the bottom
            const chatHistory = this.$refs.chatHistory;
            if (chatHistory) {
                chatHistory.scrollTop = chatHistory.scrollHeight;
            }
        },
        toggleShow(user) {
            user.show = !user.show;  // Toggle the 'show' property to show/hide task hours
            console.log(user.username, 'show:', user.show); // Debugging to check if show is toggling correctly
        },

        confirmLeave() {
            this.resetEditingStates();
            if (this.pendingNavigation) {
                this.pendingNavigation();
                this.pendingNavigation = null;
            }
            const modal = $('#unsavedChangesModal');
            modal.modal('hide');
        },
        parseLinks(text) {
            if (!text) return '';

            const urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function (url) {
                return `<a href="${url}" target="_blank" class="link_url underline">${url}</a>`;
            });
        },
        handleRowClick(subtaskId, event) {
            // Prevent navigation if it's a selection click or came from a control (like button, checkbox, etc.)
            if (event.target.closest('button, a, input, [data-stop-propagation]')) return;

            this.$router.push({ path: 'subtask', query: { id: subtaskId } });
        },
        formatDate(date) {
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
            const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month (0-based index) and pad
            const year = d.getFullYear(); // Get full year

            return `${day}/${month}/${year}`; // Return formatted date in dd/mm/yyyy
        },
        roundToTwoDecimalPlaces(number) {
            return number.toFixed(2); // Round to two decimal places
        },
        resetEditingStates() {
            this.isEditingInfo = false;
            this.isEditingManagersBrief = false;
            this.isEditingGeneral = false;
        },
        canEditTask(task) {
            if (!task) { return false; }
            return localStorage.getItem('current_user_id') == task.info?.createdBy && this.userPermissionsTasks?.edit === 1;
        },
        canEditSubtask(subtask) {
            if (!subtask) { return false; }
            return localStorage.getItem('current_user_id') == subtask.info?.createdBy && this.userPermissionsSubTasks?.edit === 1;
        },
        scrollToEnd() {
            this.$nextTick(() => {
                const chatHistory = this.$refs.chatHistory;
                if (chatHistory) {
                    chatHistory.scrollTop = chatHistory.scrollHeight;
                }
            });
        },

        editTask() {
            this.isEditingInfo = true;
        },
        editTaskManager() {
            this.isEditingManagersBrief = true;
        },

        cancelEditing() {
            this.isEditingInfo = false;

        },
        cancelEditingManager() {
            this.isEditingManagersBrief = false;
        },

        async saveInfo() {
            try {
                // Prepare the payload with both `id` and `body`
                const payload = {
                    id: this.$route.params.id, // ID from route parameters
                    body: this.taskViewData.info.body // Editor content
                };

                const toast = useToast();


                // Call the updateInfo service with the correct payload
                const response = await updateInfo(this.taskViewData.info);

                // Show success message
                if (response.data.success) {
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message);
                }

                // Exit editing mode
                this.isEditingInfo = false;
            } catch (error) {
                // Handle any errors that occur during the API call
                console.error('Error updating information:', error);
            }
        },

        async saveManager() {
            try {
                // Prepare the payload with both `id` and `body`
                const payload = {
                    id: this.$route.params.id, // ID from route parameters
                    manager_brief: this.taskViewData.info.manager_brief // Editor content
                };

                const toast = useToast();


                // Call the updateInfo service with the correct payload
                const response = await updateManager(this.taskViewData.info);

                // Show success message
                if (response.data.success) {
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message);
                }

                // Exit editing mode
                this.isEditingManagersBrief = false;
            } catch (error) {
                // Handle any errors that occur during the API call
                console.error('Error updating information:', error);
            }
        },

        submitComment() {
            // Your submit comment logic here
            this.scrollToEnd(); // Scroll to end after adding new comment
        },
        async fetchManagersData() {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    this.managers = response.data.data;
                }
            } catch (error) {
                console.error('Failed to fetch managers:', error);
            }
        },
        async fetchCreatorsData() {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    this.creators = response.data.data;
                } else {
                    console.error("Failed to fetch creators:", response.data.message);
                }
            } catch (error) {
                console.error("Failed to fetch creators:", error);
            }
        }
    },
    watch: {
        // Watch for changes in comments and scroll to the bottom when updated
        'taskViewData.comments'(newComments, oldComments) {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        }
    },
    updated() {
        // Ensure the view scrolls to the bottom after every update
        if (this.activeTab === 'taskChat') {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        }
    },
    mounted() {
        // Scroll to the bottom when the component is first loaded
        this.$nextTick(() => {
            this.scrollToBottom();
        });
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission'
        }),
        canCreate() {
            return this.userPermissionsTasks?.create === 1;
        },
        canUpdate() {
            return this.userPermissionsTasks?.create === 1;
        },
        canArchive() {
            return this.userPermissionsSubTasks?.archive === 1;
        },
        canArchiveSubtask() {
            return this.userPermissionsSubTasks?.archive === 1;
        },
        canCreateSubtask() {
            return this.userPermissionsSubTasks?.create === 1;
        },
        userPermissionsTasks() {
            return this.getUserPermission('Tasks');
        },
        userPermissionsSubTasks() {
            return this.getUserPermission('Subtasks');
        },
        canEditTaskCreator() {
            return this.userPermissionsTasks?.editCreator === 1;
        },
        canEditSubTaskCreator() {
            return this.userPermissionsSubTasks?.editCreator === 1;
        },
        canEditAllTasks() {
            return this.userPermissionsTasks?.editAll === 1;
        },
        canEditAllSubtasks() {
            return this.userPermissionsSubTasks?.editAll === 1;
        },
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        getUser() {
            return this.$store.state.userInfo.id;
        },
        currentUser() {
            return localStorage.getItem('current_user_id'); // Safely retrieve the ID once
        }

    },
    beforeRouteLeave(to, from, next) {
        if (this.isEditingInfo || this.isEditingManagersBrief || this.isEditingGeneral) {
            this.pendingNavigation = next;
            const modal = $('#unsavedChangesModal');
            modal.modal('show');
        } else {
            next();
        }
    },
    mounted() {
        // Initial scroll to end after the component mounts
        this.scrollToEnd();
        this.fetchManagersData();
        this.fetchCreatorsData();
        this.fetchReportData();
    },
    watch: {
        'taskViewData.comments': function (newComments) {
            if (newComments && newComments.length) {
                // Scroll to the end when comments are loaded or updated
                this.scrollToEnd();
            }
        }
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const toast = useToast();
        const activeTab = ref(route.query.activeTab || 'info');
        const newComment = ref('');
        const startDate = ref('');
        const endDate = ref('');
        const showAutocomplete = ref(false);
        const subtaskIdToArchive = ref(null); // Store the ID of the task to archive
        const users = ref([]);
        const managers = ref([]);
        const creators = ref([]);
        const isEditingGeneral = ref(false); // Ensure this is defined as a ref
        const managerSelectTask = ref(null);
        const assignedUsersSelectTask = ref(null);
        const managerSelectSubTask = ref(null);
        const assignedUsersSelectSubTask = ref(null);

        const selectManager = (manager) => {
            selectedManager.value = manager.username;
            isDropdownOpen.value = false;  // Close the dropdown after selection
            updateManagerFilter(manager.id); // Call your update manager filter function
        };

        const openArchiveConfirmation = (subtaskId) => {
            subtaskIdToArchive.value = subtaskId;
            $('#archiveConfirmationModal').modal('show'); // Show the confirmation modal
        };

        const confirmArchive = async () => {
            if (!subtaskIdToArchive.value) return;

            try {
                const response = await massArchiveSubTasks({ ids: [subtaskIdToArchive.value] });
                if (response.data.success) {
                    useToast().success('Subtask archived successfully');
                    fetchData(); // Refresh the subtasks list
                } else {
                    useToast().error('Failed to archive subtask');
                }
            } catch (error) {
                useToast().error('An error occurred while archiving');
            } finally {
                $('#archiveConfirmationModal').modal('hide'); // Close the modal
                subtaskIdToArchive.value = null;
            }
        };

        const setActiveTab = (tab) => {
            activeTab.value = tab
            router.replace({ query: { ...route.query, activeTab: tab } })
        };

        const filterUsernames = () => {
            const input = newComment.value;
            const match = input.match(/@(\w*)$/); // Match @username pattern

            if (match) {
                const searchTerm = match[0].substring(1); // Extract text after '@'

                // Call the filtering logic only if there are at least 2 characters after "@"
                if (searchTerm.length >= 2) {

                    const query = match[1].toLowerCase();
                    filteredUsernames.value = users.value.filter(user =>
                        user.username.toLowerCase().includes(query)
                    );
                    showAutocomplete.value = filteredUsernames.value.length > 0;
                } else {
                    showAutocomplete.value = false;
                }
            } else {
                showAutocomplete.value = false;
            }
        };

        // Watch for changes to startDate and endDate and update URL filters
        watch([startDate, endDate], ([newStartDate, newEndDate]) => {
            router.push({
                path: '/task',
                query: { ...route.query, startDate: newStartDate, endDate: newEndDate },
            });
        });
        watch(() => route.query.activeTab, (newVal) => {
            if (newVal) {
                activeTab.value = newVal
            }
        });
        const taskData = ref({
            id: '',
            projectId: '0',
            title: '',
            description: '',
            assignedUsers: [],
            managerId: '',
            statusId: '',
            startDate: '',
            endDate: ''
        });

        const subTaskData = ref({
            id: '',
            taskId: route.query.id || 0,
            title: '',
            body: '',
            assignedUsers: [],
            managerId: '',
            statusId: '0',
            startDate: '',
            endDate: ''
        });

        const allData = ref({});
        const taskViewData = ref(null);
        const selectedSubTaskIds = ref([]);
        const selectedManager = ref('');

        const isDropdownOpen = ref(false);
        const filteredUsernames = ref([]);
        const currentUserInfo = ref(null);


        const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { id: route.query.id, page: route.query.page || 1, archived: route.query.archived || 0, statusId: route.query.statusId || 2 }, { id: route.query.id, page: 1, archived: 0, statusId: 2 });

        const createFolder = async (id) => {
            const r = await creeateTaskFolder(id);
            if (r.data.success) {
                toast.success(r.data.message);
                taskViewData.value = (await getTask({ id: route.query.id })).data.data;
            } else {
                toast.error(r.data.message)
            }
        };

        const toggleSubTaskSelection = (subTaskId) => {
            // if (!selectedSubTaskIds.value.includes(subTaskId)) {
            //     selectedSubTaskIds.value.push(subTaskId);
            // } else {
            //     selectedSubTaskIds.value = selectedSubTaskIds.value.filter(id => id !== subTaskId);
            // }
        };

        const createSubtask = async () => {
            const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "tasks", entityId: route.query.id } });
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            subTaskData.value = {
                taskId: route.query.id || 0,
                title: '',
                manager_brief: '',
                body: '',
                assignedUsers: [],
                managerId: '',
                statusId: '0',
                totalHours: '',
                startDate: '',
                endDate: ''
            };
            $("#create-subtask-form").modal('toggle');
        };

        const getStatusStyle = (id) => statusStyle(id, 'min-width:9em; height:2.5em;');
        const submitComment = async () => {
            const response = await createComment({ "id": route.query?.id, comment: newComment.value });
            if (response.data.success) {
                newComment.value = '';
                taskViewData.value = (await getTask({ id: route.query?.id })).data.data;
                $(".chat-history").animate({ scrollTop: $(".chat-history")[0].scrollHeight }, 1000);
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        };

        /* const editTask = async (id) => {
            const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "tasks" } });
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            const taskInfo = await getTask({ id });
            let taskDataValue = taskInfo.data.data.info;
            taskDataValue.managerId = taskInfo.data.data.manager?.id;
            taskDataValue.statusId = taskInfo.data.data.status?.id;
            taskDataValue.assignedUsers = taskInfo.data.data.assigned?.map((u) => u.id);
            taskDataValue.projectId = taskInfo.data.data.project?.id;
            taskData.value = taskDataValue;
            $("#create-task-form").modal('toggle');
        }; */

        const editSubTask = async (id) => {
            const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "tasks", entityId: route.query.id } });

            if (!tmpAllData.data?.success) {
                toast.error('Failed to load subtask support data.');
                return;
            }

            let newData = { users: [], statuses: [], clients: [], services: [] };

            tmpAllData.data.users.forEach(user => {
                newData.users.push({ id: user.id, text: user.username });
            });
            tmpAllData.data.statuses.forEach(status => {
                newData.statuses.push({ id: status.id, text: status.description });
            });
            tmpAllData.data.clients.forEach(client => {
                newData.clients.push({ id: client.id, text: client.title });
            });
            tmpAllData.data.services.forEach(service => {
                newData.services.push({ id: service.id, text: service.title });
            });

            allData.value = newData;

            const subTaskInfo = await getSubtask({ id });

            if (!subTaskInfo.data?.success) {
                toast.error('Failed to load subtask details.');
                return;
            }

            let subtaskDataValue = subTaskInfo.data.data.info;
            subtaskDataValue.managerId = subTaskInfo.data.data.manager?.id;
            subtaskDataValue.statusId = subTaskInfo.data.data.status?.id;
            subtaskDataValue.assignedUsers = subTaskInfo.data.data.assigned?.map((u) => u.id);
            subtaskDataValue.projectId = subTaskInfo.data.data.project?.id;

            subTaskData.value = subtaskDataValue;

            $("#create-subtask-form").modal('toggle');

        };


        const saveGeneral = async () => {
            const response = await updateGeneral(taskData.value);
            response.data.success ? toast.success(response.data.message) : toast.error(response.data.message);
            taskViewData.value = (await getTask({ id: route.query.id })).data.data;
            fetchData();
            response.data.success ? isEditingGeneral.value = false : isEditingGeneral.value = true;
        };

        const editTaskGeneral = async () => {
            try {
                const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "tasks", entityId: route.query.id } });
                let newData = { users: [], statuses: [], clients: [], services: [] };

                for (let i = 0; i < tmpAllData.data.users.length; i++) {
                    newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
                }
                for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                    newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
                }
                for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                    newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
                }
                for (let i = 0; i < tmpAllData.data.services.length; i++) {
                    newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
                }

                allData.value = newData; // `allData` is a ref, so use `.value`

                const taskInfo = await getTask({ id: route.query.id });
                let taskDataValue = taskInfo.data.data.info;
                taskDataValue.managerId = taskInfo.data.data.manager?.id;
                taskDataValue.statusId = taskInfo.data.data.status?.id;
                taskDataValue.assignedUsers = taskInfo.data.data.assigned?.map((u) => u.id);
                taskDataValue.projectId = taskInfo.data.data.project?.id;

                taskData.value = taskDataValue; // `subTaskData` is a ref, so use `.value`

            } catch (error) {
                console.error('Error in editSubTaskGeneral:', error);
            }

            isEditingGeneral.value = true; // Use `.value` for reactive refs
        };

        const cancelEditingGeneral = async () => {
            isEditingGeneral.value = false;

        };


        const submitTaskForm = async () => {
            const response = await createOrUpdateTask(taskData.value);
            response.data.success ? toast.success(response.data.message) : toast.error(response.data.message);
            taskViewData.value = (await getTask({ id: route.query.id })).data.data;
            $("#create-task-form").modal('toggle');
        };

        const submitSubTaskForm = async () => {
            const response = await createOrUpdateSubtask(subTaskData.value);

            if (response.data.success) {
                toast.success(response.data.message);
                fetchData();
                $("#create-subtask-form").modal('toggle');
            } else {
                toast.error(response.data.message);

            }
        };


        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };

        const tinymceInit = {
            height: 300,
            license_key: 'gpl',
            ...editorSkin(),
            plugins: 'link autolink',
            toolbar: 'undo redo | bold italic underline | link',
        };

        const select2SettingsTask = {
            dropdownParent: '#create-task-form .modal-content',
            placeholder: "Please select"
        };

        const handleKeyup = async (event) => {
            const mentionQuery = event.target.value.split('@').pop();
            const unamesResponse = await searchUsers({ search: mentionQuery });
            filteredUsernames.value = unamesResponse.data.data.map(user => user.info.username);
        };

        const selectUsername = (username) => {
            newComment.value = newComment.value.replace(/@(\w*)$/, `@${username} `);
            filteredUsernames.value = [];
            showAutocomplete.value = false;
        };

        const updateManagerFilter = (managerId) => {
            // Now, managerId is passed directly from the selectManager method
            updateFilters({ ...filters.value, managerFilter: managerId, page: 1 });
        };
        const selectStatus = async (taskId, statusId) => {
            const r = await updateTaskStatus(taskId, statusId);
            if (r.data.success) {
                useToast().success(r.data.message);
                const taskInfo = await getTask({ id: taskId });
                taskViewData.value = taskInfo.data.data;
            } else {
                useToast().error(r.data.message);
            }
        };

        const statuses = ref([]);

        // const getStatusIcon = (id) => {
        //     const status = statuses.value.find((s) => s.id === id);
        //     return status ? status.icon : "";
        // };
        const getStatusIcon = (id) => {
            const status = statuses.value.find(s => s.id === id);
            return status ? require(`@/assets/images/${status.img}`) : '';
        };

        const getCurrentStatus = (id) => {
            const status = statuses.value.find((s) => s.id === id);
            return status ? status.description : "Select Status";
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({ path: '/task', query: { ...route.query, search: $("#main-search-input").val() } });
            }, 300);
        };

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const handleClickOutside = (event) => {
            const dropdown = document.querySelector('.autocomplete-dropdown');
            const textarea = document.getElementById('commentTextarea');

            if (
                (dropdown && !dropdown.contains(event.target)) &&
                (!textarea || !textarea.contains(event.target))
            ) {
                showAutocomplete.value = false;
            }
        };

        const filteredUsersForManagerTask = computed(() => {
            return allData.value.users?.filter(user =>
                !taskData.value.assignedUsers.includes(String(user.id))
            ) || [];
        });

        const filteredUsersForAssignedTask = computed(() => {
            return allData.value.users?.filter(user =>
                String(user.id) !== taskData.value.managerId
            ) || [];
        });

        watch(() => taskData.value.managerId, (newManagerId) => {
            if (taskData.value.assignedUsers.includes(newManagerId)) {
                taskData.value.assignedUsers = taskData.value.assignedUsers.filter(id => id !== newManagerId);
            }

            // Force re-render of assigned users select
            nextTick(() => {
                assignedUsersSelectTask.value?.$forceUpdate?.();
            });
        });

        watch(() => taskData.value.assignedUsers, (newAssigned) => {
            if (newAssigned.includes(taskData.value.managerId)) {
                taskData.value.managerId = '';
            }

            // Force re-render of manager select
            nextTick(() => {
                managerSelectTask.value?.$forceUpdate?.();
            });
        });


        const filteredUsersForManagerSubTask = computed(() => {
            return allData.value.users?.filter(user =>
                !subTaskData.value.assignedUsers.includes(String(user.id))
            ) || [];
        });

        const filteredUsersForAssignedSubTask = computed(() => {
            return allData.value.users?.filter(user =>
                String(user.id) !== subTaskData.value.managerId
            ) || [];
        });

        watch(() => subTaskData.value.managerId, (newManagerId) => {
            if (subTaskData.value.assignedUsers.includes(newManagerId)) {
                subTaskData.value.assignedUsers = subTaskData.value.assignedUsers.filter(id => id !== newManagerId);
            }

            // Force re-render of assigned users select
            nextTick(() => {
                assignedUsersSelectSubTask.value?.$forceUpdate?.();
            });
        });

        watch(() => subTaskData.value.assignedUsers, (newAssigned) => {
            if (newAssigned.includes(subTaskData.value.managerId)) {
                subTaskData.value.managerId = '';
            }

            // Force re-render of manager select
            nextTick(() => {
                managerSelectSubTask.value?.$forceUpdate?.();
            });
        });


        onMounted(async () => {

            const allRequiredData = await getClientsServicesStatusesUsers({ params: { type: "tasks", entityId: route.query.id } });
            statuses.value = allRequiredData.data.statuses;
            users.value = allRequiredData.data.users;
            currentUserInfo.value = (await fetchUserInfo()).data.info;
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
            taskViewData.value = (await getTask({ id: route.query.id })).data.data;
            document.addEventListener('click', handleClickOutside);
        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
            document.removeEventListener('click', handleClickOutside);

        });

        const updateSubtaskStatusId = async (subtaskId, statusId) => {
            const r = await updateSubtaskStatus(subtaskId, statusId);
            if (r.data.success) {
                useToast().success(r.data.message);
                fetchData();
            } else {
                useToast().error(r.data.message);
            }
        };

        return {
            createFolder,
            currentUserInfo,
            sortBy,
            showAutocomplete,
            selectUsername,
            filterUsernames,
            filteredUsernames,
            confirmArchive,
            openArchiveConfirmation,
            startDate,
            endDate,
            newComment,
            updateSubtaskStatusId,
            createSubtask,
            selectStatus,
            data,
            filters,
            updateFilters,
            paginationLinks,
            activeTab,
            route,
            getPageFromUrl,
            statuses,
            getStatusIcon,
            getCurrentStatus,
            searchAction,
            allData,
            taskData,
            subTaskData,
            taskViewData,
            selectedSubTaskIds,
            selectManager,
            selectedManager,
            isDropdownOpen,
            toggleDropdown,
            closeDropdown,
            isDropdownOpen,
            dropdownStyle,
            tinymceInit,
            select2SettingsTask,
            submitTaskForm,
            submitSubTaskForm,
            submitComment,
            editSubTask,
            handleKeyup,
            filteredUsernames,
            selectUsername,
            getStatusStyle,
            updateManagerFilter,
            managers,
            editTaskGeneral,
            isEditingGeneral,
            cancelEditingGeneral,
            saveGeneral,
            setActiveTab, filteredUsersForManagerTask, filteredUsersForAssignedTask, filteredUsersForManagerSubTask, filteredUsersForAssignedSubTask,
            toggleSubTaskSelection
        };
    },
};
</script>

<style scoped>
.chat-message {
    color: black !important;
}

.project-code {
    font-size: 1.5rem;
    font-weight: bold;
}

.status-dropdown {
    position: relative;
    display: inline-block;
}

.status-button {
    background-color: #f1f1f1;
    color: #333;
    padding: 8px 16px;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 8px;

}

.status-button {
    background-color: transparent;
    color: #333;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 3px;
    border-radius: 8px;

}

.status-dropdown:hover .status-dropdown-content {
    display: flex;
}

.status-dropdown:hover .status-dropdown-content-tasks {
    display: flex;
    flex-direction: row;
    right: 0;
}

.status-dropdown-content-tasks {
    z-index: 9000;
    position: absolute;
    background-color: white;
    min-width: fit-content;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    display: none;
    flex-direction: column;
}

.status-dropdown-content {
    z-index: 9000;
    position: absolute;
    background-color: white;
    min-width: fit-content;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
    padding: 8px;
    border-radius: 8px;
    display: none;
    flex-direction: column;
    gap: 10px;
}

.status-dropdown>button {
    height: 1.5em;
}

.status-dropdown-content button {
    width: 100%;
    background: none;
    border: none;
    padding: 10px;
    text-align: left;
    font-size: 0.9rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
}

.status-dropdown-content-tasks button {
    width: 100%;
    background: none;
    border: none;
    padding: 10px;
    text-align: left;
    font-size: 0.8rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.status-dropdown-content-tasks button:hover {
    transform: scale(1.6);
    transition: .5s;
}

.status-dropdown-content button:hover {
    background-color: lightgray;
}

.active-status {
    font-weight: bold;
    background-color: #007bff;
    color: white;
    border-radius: 5px;
}

.create-task-button {
    width: 100%;
}


.nav-tabs {
    border: none;
}

/* Style for all list items to have a bottom border */
.nav-tabs .nav-item {
    border-bottom: 1px solid #DCDCDC;
    /* Light gray border for non-active items */
    /* margin-left:20px; */
}

.nav-tabs .nav-item .nav-link {
    color: #8C8C8C;
}

/* Style for the active tab to have a darker bottom border */
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link:hover {
    border-color: white;

    border-bottom: 3px solid #8C8C8C;
    /* Darker gray border for the active tab */
    color: black;

}

/* Optionally, you can remove the bottom border for non-active tabs on hover to make the UI clearer */

/* Add this CSS to ensure the button is placed on the right border */
.col-xl-8.col-lg-7.col-md-12 {
    position: relative;
    /* Make the parent div relative */
}

/* Style the button to be positioned absolutely at the border-right */
.status-button-wrapper {
    position: absolute;
    /* Position it absolutely within the parent */
    top: 50px;
    /* Vertically center the button */
    right: -25px;
    /* Position it slightly outside to touch the border-right */
    transform: translateY(-50%);
    /* Adjust for exact vertical centering */
    z-index: 10;
    /* Ensure the button stays above other elements */
}

.autocomplete-dropdown {
    position: absolute;
    z-index: 1000;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-height: 200px;
    /* Limit height */
    overflow-y: auto;
}

.autocomplete-dropdown ul {
    padding: 0;
    margin-top: 110px;
}

.autocomplete-item {
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.autocomplete-item:hover {
    background-color: #f0f0f0;
    color: #333;
}

textarea {
    resize: none;
    overflow: auto;
}

textarea:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 4px rgba(0, 123, 255, 0.25);
}

/* .sendComment {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
} */

#commentTextarea {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

.nav-tabs.tab-body-header .nav-link.active span {
    color: white;
}

#projectTableMobile {
    display: none !important;
}

.mobilefilters {
    display: none;
}

.dropdown-btn-filter {
    cursor: pointer;
    text-transform: capitalize;
    font-weight: 600;
    color: #545454;
}

.dropdown-btn {
    cursor: pointer;
}

/* Dropdown Options List */
.dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options-filters {
    position: absolute;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: fit-content;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options li,
.dropdown-options-filters li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #545454;
    font-weight: 600;
    border-bottom: 1px dashed lightgray;
}

.dropdown-options li:hover,
.dropdown-options-filters li:hover {
    background-color: #545454;
    color: white;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 90px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    width: 100%;
    /* Ensure the container is wide enough */
}

.dropdown-container:hover .dropdown-content {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: fit-content;
    padding: 8px 4px;
    border: 1px solid lightgray;
    z-index:2;
}

.dropdown-content button {
    display: block;
    /* Make buttons stack vertically */
    width: 100%;
    /* Make buttons take the full width of the container */
    margin: 0;
    /* Remove margin to avoid spacing issues */
    box-sizing: border-box;
    /* Ensure padding does not affect width */
    margin-bottom: 3px;

}

.flex-column-desk{
    flex-direction: column;
}
::v-deep(.select2-container--default .select2-selection--multiple) {
    border: 0px
}
::v-deep(.select2-container--default .select2-selection--single .select2-selection__rendered){
    border: 0px solid var(--border-color);
}
/* Fix Select2 in Modal for Mobile */
::v-deep .select2-container {
    width: 100% !important;
}

::v-deep .select2-dropdown {
    z-index: 9999 !important;
    /* Higher than modal z-index */
}

::v-deep .modal {
    z-index: 1050;
}

::v-deep .select2-container--open {
    z-index: 9999 !important;
}
@media screen and (max-width: 1279px) {
    .tagInfo {
        display: none !important;
    }

    .rightborderSec {
        border-right: 0px !important;
    }

    .status-button-wrapper {
        top: -10px;
        right: 15px;
        transform: translateY(-100%);
    }

    .editing-actions {
        flex-direction: row;
        align-items: baseline;
    }

    .justifyContentbetmob {
        justify-content: space-between;
    }

    .savebutton {
        width: 25px !important;
    }

    .cancelbutton {
        width: 25px !important;
    }

    .editbutton {
        width: 25px !important;
    }

    .tab-content {
        border-bottom: 1px solid lightgray;
    }

    .belowEditbtn {
        top: -35px !important;
    }

    .dateprojectdiv {
        display: flex;
        align-items: center;
    }

    .dateprojectdiv img {
        width: 20px !important;
    }

    .dateprojectdiv span {
        font-size: 13px !important;
    }

    .authorsChatDiv {
        width: 85% !important;
    }

    #commentTextarea {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    #projectTableMobile {
        display: flex !important;
    }

    .mobileRows {
        /* padding: 5px 10px; */
        border-bottom: 1px dashed #dedede;
        margin-bottom: 12px;
    }

    #myProjectTable {
        display: none;
    }

    .rightCol {
        padding-left: calc(var(--bs-gutter-x) * .5);
    }

    .mobilefilters {
        display: unset;
    }

    .desktopfilters {
        display: none;
    }
    .d-flex-mob{
        display: flex;
    }
    .pipe-separator{
        display:none
    }
    .breadcrumb-mob{
        display: none !important;
    }
    .project-code {
        font-size: 1.25rem;
    }
    .flex-column-desk{
        flex-direction: unset;
    }

        ::v-deep .select2-container--default .select2-selection--single {
        height: 38px;
        padding: 6px 12px;
    }

    ::v-deep .select2-container--default .select2-selection--multiple {
        min-height: 38px;
        padding: 3px;
    }

    ::v-deep .select2-dropdown {
        max-height: 200px;
        overflow-y: auto;
    }

    /* Ensure modal scrolls properly on mobile */
    .modal-dialog-scrollable .modal-body {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
}
</style>
